// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__1mtOq","vLegacy":"SelectSecondary_vLegacy__3oaXI","error":"SelectSecondary_error__1OvxR","disabled":"SelectSecondary_disabled__2YGz2"};